<template>
    <div class="gofixInput gofixDropdownInput" v-bind:class="{gofixInputHasDesc:desc,gofixInputError : (required && !value && blurInput),gofixInputDisable:disabled}">
        <div class="mainInput">
            <v-select
                    :searchable="false"
                    :value="value"
                    :options="suppliers"
                    :calculate-position="calculatePosition"
                    label="name"
                    class="gofixVueSelect gofixSupplierDropdown"
                    v-bind:class="{'vs--selected' : value}"
                    @input="handleInput"
                    @search:blur="blurInput = true"
                    :append-to-body="appendToBody"
                    :disabled="disabled"
                    :reduce="reduce"
            >
                <template #option="{ name, contract_supplier }">
                    <span class="c-000000">{{name}}</span>
                    <span class="date-base" v-if="contract_supplier && contract_supplier.contract_terms && contract_supplier.contract_terms[0] && contract_supplier.contract_terms[0].start_date && contract_supplier.contract_terms[0].end_date">
                                            From: {{contract_supplier.contract_terms[0].start_date | formatDatebyMoment('YYYY-MM-DD HH:mm:ss','DD.MM.YYYY')}} to {{contract_supplier.contract_terms[0].end_date | formatDatebyMoment('YYYY-MM-DD HH:mm:ss','DD.MM.YYYY')}}
                                        </span>
                </template>
                <template #list-footer>
                    <li class="loadMoreSelect" v-if="activeLevel < 3" @click="showMoreSupplier">{{activeLevel === 1 ? 'Show supplier eligible to contract' : 'Show all supplier'}}</li>
                    <li class="loadMoreSelect" v-if="activeLevel === 3" @click="showLessSupplier">Collapse</li>
                </template>
            </v-select>
            <div class="label">{{label}}</div>
        </div>
        <p class="desc" v-if="desc" v-html="desc"></p>
    </div>
</template>

<script>
    import { createPopper } from '@popperjs/core';
    export default {
        name: "dropdown-supplier",
        props: {
            label: {
                type: String,
                required: false,
                default: () => "Supplier Name"
            },
            value: {
                required: true,
                default: () => null
            },
            required: {
                type: Boolean,
                required: false,
                default: () => false
            },
            desc: {
                type: String,
                required: false,
                default: () => null
            },
            contractId: {
                type: Number,
                required: false,
                default: () => null
            },
            propertyId: {
                type: Number,
                required: false,
                default: () => null
            },
            serviceCategoryId: {
                type: Number,
                required: false,
                default: () => null
            },
            placement: {
                type: String,
                required: false,
                default: () => "bottom"
            },
            appendToBody: {
                type: Boolean,
                required: false,
                default: () => true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            reduce: {
                type: Function,
                default: option => option,
            },
        },

        data() {
            return {
                allSuppliers: null,
                activeLevel: 1,
                suppliers:[],
                loading: false,
                blurInput: false,
            }
        },
        watch: {
            contractId : function (val) {
                this.getSupplier(this.contractId,this.propertyId,this.serviceCategoryId);
            },
            propertyId : function (val) {
                this.getSupplier(this.contractId,this.propertyId,this.serviceCategoryId);
            },
            serviceCategoryId : function (val) {
                this.getSupplier(this.contractId,this.propertyId,this.serviceCategoryId);
            },

        },
        created(){
            this.getSupplier(this.contractId,this.propertyId,this.serviceCategoryId);
        },
        methods: {
            getSupplier(contract_id = null,property_id = null,service_category_id = null){
                if(this.loading) {
                    clearTimeout(this.loading);
                    this.loading = null;
                }
                this.loading = setTimeout(() => {
                    this.$store.dispatch("OrganizationController/getRelateSupplier",{
                        contract_id:contract_id,
                        property_id: property_id,
                        service_category_id: service_category_id,
                        filter:null
                    })
                        .then(response => {
                            this.allSuppliers = response;
                            if(response.tier_1){
                                this.suppliers = response.tier_1;
                                this.activeLevel = 1;
                                this.$emit('supplier', this.suppliers)
                            }else if(response.tier_2){
                                this.suppliers = response.tier_2;
                                this.activeLevel = 2;
                            }else if(response.tier_3){
                                this.suppliers = response.tier_3;
                                this.activeLevel = 3;
                            }
                        })
                        .catch( err => {
                            console.log(err)
                        })
                }, 0);
            },
            showMoreSupplier(){
                switch (this.activeLevel) {
                    case 1:
                        this.suppliers = this.suppliers.concat(this.allSuppliers.tier_2);
                        this.activeLevel = 2;
                        break;
                    case 2:
                        this.suppliers = this.suppliers.concat(this.allSuppliers.tier_3);
                        this.activeLevel = 3;
                        break;
                }
            },
            showLessSupplier(){
                if(this.allSuppliers.tier_1){
                    this.suppliers = this.allSuppliers.tier_1;
                    this.activeLevel = 1;
                }else if(this.allSuppliers.tier_2){
                    this.suppliers = this.allSuppliers.tier_2;
                    this.activeLevel = 2;
                }else if(this.allSuppliers.tier_3){
                    this.suppliers = this.allSuppliers.tier_3;
                    this.activeLevel = 3;
                }
            },
            handleInput (e) {
                this.$emit("input", e);
                this.$emit("change", e);
            },
            calculatePosition (dropdownList, component, {width}) {
                dropdownList.style.width = width;
                const popper = createPopper(component.$refs.toggle, dropdownList, {
                    placement: this.placement,
                    modifiers: [
                        {
                            name: 'offset', options: {
                                offset: [0, -1]
                            }
                        },
                        {
                            name: 'toggleClass',
                            enabled: true,
                            phase: 'write',
                            fn ({state}) {
                                component.$el.classList.toggle('drop-up', state.placement === 'top')
                            },
                        }]
                });
                return () => popper.destroy();
            }
        }
    }
</script>

<style scoped>

</style>
